import type {CalendarData,CalendarEvent} from '@artemis-group/aiw-contracts';
import type {MonthlyPerformance} from '@aiw/api-client';
import {monday,shiftDay} from './calendar-days';

export type UnscheduledOperation = (MonthlyPerformance['scheduled']['jobs'][number]|MonthlyPerformance['pending_schedule']['jobs'][number]) & {source:'scheduled'|'pending'};

/** A read-only projection of existing schedule facts. A missing date remains missing: no replacement date is inferred. */
export function projectOperations(
 calendar:Pick<CalendarData,'events'>,
 performance:Pick<MonthlyPerformance,'scheduled'|'pending_schedule'>,
 today:string,
){
 const start=monday(today),nextStart=shiftDay(start,7),end=shiftDay(nextStart,6);
 const inRange=(event:CalendarEvent,from:string,to:string)=>event.date>=from&&event.date<=to;
 const delayed=performance.scheduled.jobs.filter(job=>job.date_passed);
 const seen=new Set<string>(),unscheduled:UnscheduledOperation[]=[];
 for(const [source,jobs] of [['scheduled',performance.scheduled.jobs],['pending',performance.pending_schedule.jobs]] as const){
  for(const job of jobs)if(!job.date&&!seen.has(job.ref)){seen.add(job.ref);unscheduled.push({...job,source});}
 }
 return {
  range:{start,nextStart,end},
  thisWeek:calendar.events.filter(event=>inRange(event,start,shiftDay(nextStart,-1))),
  nextWeek:calendar.events.filter(event=>inRange(event,nextStart,end)),
  delayed,
  unscheduled,
 };
}
